(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // ----------------------------
  // Robust swatches + image swap (Horizon-safe)
  // - Updates ALL media images in the card (primary + secondary)
  // - Mobile: first tap previews (NO navigation), second tap navigates
  // ----------------------------

  const isTouchLike = () => {
    const mm =
      window.matchMedia &&
      (window.matchMedia('(hover: none)').matches ||
        window.matchMedia('(pointer: coarse)').matches);
    const tp =
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      'ontouchstart' in window;
    return !!(mm || tp);
  };

  // Per-card state
  const cardState = new WeakMap();
  function getItemState(item) {
    if (!item) return null;
    if (!cardState.has(item)) cardState.set(item, {});
    return cardState.get(item);
  }

  function findMediaContainer(item) {
    if (!item) return null;
    return (
      item.querySelector('.card-gallery') ||
      item.querySelector('[data-product-media]') ||
      item.querySelector('.product-grid__media') ||
      item.querySelector('.product-card__media') ||
      item.querySelector('.media') ||
      (item.querySelector('picture') && item.querySelector('picture').parentElement) ||
      (item.querySelector('img') && item.querySelector('img').parentElement) ||
      null
    );
  }

  // Get ALL product images in card (primary + secondary), excluding swatch thumbs/overlay
  function getAllCardMediaImages(item) {
    if (!item) return [];

    const all = Array.from(
      item.querySelectorAll(
        '.card-gallery img, [data-product-media] img, .product-grid__media img, .product-card img, picture img, img'
      )
    );

    // Exclude swatch overlay thumbs
    const filtered = all.filter((img) => !img.closest('.variant-swatches-overlay'));

    // De-dupe
    const uniq = [];
    const seen = new Set();
    for (const img of filtered) {
      if (seen.has(img)) continue;
      seen.add(img);
      uniq.push(img);
    }
    return uniq;
  }

  function getPictureSources(img) {
    const pic = img ? img.closest('picture') : null;
    if (!pic) return [];
    return Array.from(pic.querySelectorAll('source'));
  }

  // Store originals for all images in the card (so restore always works)
  function storeOriginalForItem(item) {
    if (!item) return;
    const st = getItemState(item);
    if (!st) return;
    if (st.originalStored) return;

    const imgs = getAllCardMediaImages(item);
    if (!imgs.length) return;

    st.originalStored = true;
    st.originals = imgs.map((img) => {
      const sources = getPictureSources(img);
      return {
        img,
        src: img.currentSrc || img.src || '',
        srcset: img.getAttribute('srcset') || '',
        sources: sources.map((s) => s.getAttribute('srcset') || '')
      };
    });
  }

  // Swap ALL images (primary + secondary) to the swatch image URL
  function swapMediaToItem(item, url) {
    if (!item || !url) return;

    storeOriginalForItem(item);

    const imgs = getAllCardMediaImages(item);
    if (!imgs.length) return;

    for (const img of imgs) {
      const sources = getPictureSources(img);
      if (sources.length) sources.forEach((s) => s.setAttribute('srcset', url));

      img.src = url;
      img.setAttribute('srcset', url);
      img.setAttribute('data-src', url);
      img.setAttribute('data-srcset', url);
    }
  }

  function restoreMediaForItem(item) {
    if (!item) return;
    const st = getItemState(item);
    if (!st || !st.originalStored || !Array.isArray(st.originals)) return;

    for (const o of st.originals) {
      const img = o.img;
      if (!img || !img.isConnected) continue;

      const sources = getPictureSources(img);
      if (sources.length && Array.isArray(o.sources)) {
        sources.forEach((s, i) => s.setAttribute('srcset', o.sources[i] || ''));
      }

      if (o.src) img.src = o.src;
      img.setAttribute('srcset', o.srcset || '');
      if (o.src) img.setAttribute('data-src', o.src);
      img.setAttribute('data-srcset', o.srcset || '');
    }
  }

  // Active ring handling
  function setActiveSwatch(item, swatchEl) {
    if (!item) return;
    item.querySelectorAll('.variant-swatch').forEach((el) => el.classList.remove('is-active'));
    if (swatchEl) swatchEl.classList.add('is-active');
  }

  function setActiveToCurrent(item) {
    if (!item) return;
    const current = item.getAttribute('data-current-handle');
    if (!current) return;
    const match = item.querySelector(`.variant-swatch[data-handle="${CSS.escape(current)}"]`);
    if (match) setActiveSwatch(item, match);
  }

  // Mount overlay into media early to avoid jump
  function mountSwatchesIntoMedia(scope = document) {
  scope.querySelectorAll('.product-grid__item').forEach((item) => {
    const media = findMediaContainer(item);
    if (!media) return;

    const cs = window.getComputedStyle(media);
    if (cs.position === 'static') media.style.position = 'relative';

    item.querySelectorAll('.variant-swatches-overlay, .card-size-options-overlay').forEach((overlay) => {
      if (overlay.parentElement !== media) media.appendChild(overlay);
      overlay.classList.add('is-mounted');
    });
  });
}

  (function earlyMountLoop() {
    try {
      mountSwatchesIntoMedia(document);
    } catch (e) {}
    let frames = 0;
    const tick = () => {
      frames += 1;
      try {
        mountSwatchesIntoMedia(document);
      } catch (e) {}
      if (frames < 40) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  })();

  document.addEventListener('DOMContentLoaded', () => {
    mountSwatchesIntoMedia(document);

    const root = document.querySelector('[section-id]');
    if (!root) return;

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          mountSwatchesIntoMedia(root);
          break;
        }
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  });

  // ----------------------------
  // Desktop hover
  // ----------------------------
  document.addEventListener(
    'mouseover',
    (e) => {
      const swatch = e.target.closest('.variant-swatch');
      if (!swatch) return;
      if (isTouchLike()) return;

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      e.stopPropagation();

      const main = swatch.getAttribute('data-variant-main');
      if (main) swapMediaToItem(item, main);

      setActiveSwatch(item, swatch);
    },
    true
  );

  // Restore when leaving the overlay entirely
  document.addEventListener(
    'mouseout',
    (e) => {
      const overlay = e.target.closest('.variant-swatches-overlay');
      if (!overlay) return;
      if (isTouchLike()) return;

      if (overlay.contains(e.relatedTarget)) return;

      const item = overlay.closest('.product-grid__item');
      if (!item) return;

      e.stopPropagation();

      restoreMediaForItem(item);
      setActiveToCurrent(item);
    },
    true
  );

  // ----------------------------
  // Mobile: first tap preview (NO navigation), second tap navigates
  // ----------------------------

  // Clear "armed" if tapping elsewhere
  document.addEventListener(
    'pointerdown',
    (e) => {
      const clickedSwatch = e.target.closest('.variant-swatch');
      if (clickedSwatch) return;
      document
        .querySelectorAll('.variant-swatch[data-armed="1"]')
        .forEach((el) => el.removeAttribute('data-armed'));
    },
    true
  );

  // First tap handled on pointerdown (preview)
  document.addEventListener(
    'pointerdown',
    (e) => {
      const swatch = e.target.closest('.variant-swatch');
      if (!swatch) return;

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      if (!isTouchLike()) return;

      e.stopPropagation();

      const main = swatch.getAttribute('data-variant-main');

      if (swatch.getAttribute('data-armed') !== '1') {
        // First tap: preview
        e.preventDefault();

        item
          .querySelectorAll('.variant-swatch[data-armed="1"]')
          .forEach((el) => el.removeAttribute('data-armed'));
        swatch.setAttribute('data-armed', '1');

        if (main) swapMediaToItem(item, main);
        setActiveSwatch(item, swatch);

        window.clearTimeout(swatch._armTimer);
        swatch._armTimer = window.setTimeout(() => {
          swatch.removeAttribute('data-armed');
        }, 2000);

        return;
      }

      // Second tap: allow navigation (no preventDefault)
    },
    true
  );

  // ✅ IMPORTANT: stop the FIRST click navigation as well (some browsers still follow the link on click)
  document.addEventListener(
    'click',
    (e) => {
      const swatch = e.target.closest('.variant-swatch');
      if (!swatch) return;
      if (!isTouchLike()) return;

      // If this is the "first tap" (armed just set by pointerdown), do NOT navigate
      // We keep it armed="1" for second tap navigation.
      if (swatch.getAttribute('data-armed') === '1') {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // Scroll to card when URL has a hash
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

 document.addEventListener(
  'mouseover',
  (e) => {
    const size = e.target.closest('.card-size-option');
    if (!size) return;
    if (isTouchLike()) return;

    const item = size.closest('.product-grid__item');
    if (!item) return;

    e.stopPropagation();

    const main = size.getAttribute('data-variant-main');
    if (main) swapMediaToItem(item, main);
  },
  true
);

document.addEventListener(
  'mouseout',
  (e) => {
    const overlay = e.target.closest('.card-size-options-overlay');
    if (!overlay) return;
    if (isTouchLike()) return;

    if (overlay.contains(e.relatedTarget)) return;

    const item = overlay.closest('.product-grid__item');
    if (!item) return;

    e.stopPropagation();

    restoreMediaForItem(item);
  },
  true
);


  } catch(e) { console.error(e); }
})();
})();
